import React from "react";
import {
    Box,
    Button,
    Divider,
    Grid,
    Typography,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditNoteIcon from '../../../img/edit-icon.svg';
import { SavedPaymentPayload } from "@/app/models/checkout/types";

export type PaymentInformationSavedProps = {
    savedPaymentPayload: SavedPaymentPayload;
    enablePromotionsSection: boolean;
    onEdit: () => void;
};

const PaymentInformationSaved: React.FC<PaymentInformationSavedProps> = ({
    savedPaymentPayload,
    enablePromotionsSection,
    onEdit
}) => {

    const showImpactRewards =
        enablePromotionsSection &&
        savedPaymentPayload.selectedRewardPoints != null &&
        Number(savedPaymentPayload.selectedRewardPoints) > 0

    return (
        <Box>
            <Box sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <CheckCircleIcon sx={{ color: "#64A70B", padding: "1px", fontSize: "36px", mr: 1, }} />
                    <Typography className='checkout-container-title'>
                        Payment
                    </Typography>

                    <Divider className="checkout-divider" />
                </Box>
            </Box>

            <Box sx={{ border: '10px solid', borderColor: 'grey.300', borderRadius: 2, p: 3 }}>
                <Grid container alignItems="flex-start">
                    <Grid item xs={12} md={6}>
                        <Box mb={2}>
                            <Typography component="div" fontWeight={700} fontSize={14}>
                                Payment Type:
                            </Typography>
                            <Typography component="div" fontSize={14}>
                                {savedPaymentPayload.paymentTerms}
                            </Typography>
                        </Box>

                        {showImpactRewards && (
                            <Box>
                                <Typography component="div" fontWeight={700} fontSize={14}>
                                    Impact Rewards:
                                </Typography>
                                <Typography component="div" fontSize={14}>
                                    ${savedPaymentPayload.selectedRewardPoints}
                                </Typography>
                            </Box>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}
                        display="flex"
                        justifyContent="flex-end"
                        alignItems="flex-start">
                        <Button
                            id="billing-edit-btn"
                            type="button"
                            onClick={onEdit}
                            startIcon={<img src={EditNoteIcon} alt=""/>}
                            sx={{ fontWeight: 700, color: "#003B5C", textTransform: "none" }}>
                            Edit
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default PaymentInformationSaved;
